<template>
  <div class="box-father">
    <div style="height: 100%" v-if="!dialogTableVisible">
      <div class="box-header">
        <div class="box-header-left">
          <div class="box-header-left-text">业务基础信息管理&nbsp;/&nbsp;</div>
          <div class="box-header-right">
            <div>人员标签</div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="biaodan2">
          <div class="biaodan-left">
            <div style="height: 100%; width: 100%">
              <el-form
                :inline="true"
                label-position="left"
                class="demo-form-inline"
                :model="form"
              >
                <el-form-item label="姓名">
                  <el-input
                    v-model="form.userName"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系方式">
                  <el-input
                    v-model="form.phone"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <!-- <el-form-item label="标签名称">
                  <el-input
                    v-model="form.tagName"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="标签类型">
                  <el-input
                    v-model="form.tagType"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item> -->
                <el-form-item class="form-item">
                  <el-button @click="onSearch" class="search button-info">查询</el-button>
                  <el-button class="reset" @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="aside">
          <div style="display: flex;justify-content: space-between;margin-bottom: 10px;">
            <div style="display: flex;align-items: center;">
              <el-button type="primary" icon="el-icon-download" plain @click="downloadTemp" class="button-primary">下载模板/导出数据</el-button>
              <!-- <el-button type="primary" icon="el-icon-upload2" plain @click="exportData" class="button-primary" :loading="exportLoading">下载模板/导出数据</el-button> -->
              <!-- <el-button type="danger" icon="el-icon-delete" plain @click="multipleDelRow" class="button-danger ml-10">批量删除</el-button> -->
              <el-upload
                class="upload-demo"
                accept=".xlsx"
                action="#"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="importData"
              >
                <el-button type="text" icon="el-icon-upload" class="ml-10" :loading="importLoading">导入数据</el-button>
              </el-upload>
            </div>
            <div style="display: flex;align-items: center;">
              <el-button type="primary" icon="el-icon-price-tag" plain @click="dialogTableVisible = true" class="button-primary">标签管理</el-button>
              <el-button type="primary" icon="el-icon-user" class="button-info" @click="openBiao">人员打标</el-button>
            </div>
          </div>
          <!-- :disabled="scope.row.buttonList && scope.row.buttonList.length && scope.row.buttonList.includes('COMPILE') ? false : true"
                :class="scope.row.buttonList && scope.row.buttonList.length && scope.row.buttonList.includes('COMPILE') ? 'editClass' : ''" -->
          <!-- :disabled="scope.row.buttonList && scope.row.buttonList.length && scope.row.buttonList.includes('DELETE') ? false : true"
                :class="scope.row.buttonList && scope.row.buttonList.length && scope.row.buttonList.includes('DELETE') ? 'delClass' : ''" -->
          <common-table
            :key="renderKey"
            :page="page"
            :dataList="dataList"
            :tableData="dataList.tableData"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
            :maxHeight="540"
            :select="false"
            :selectedIdOptions="selectedIdOptions"
            @selectAll="selectAll"
            @handleSelectionChange="handleSelectionChange"
            :actionColumns="actionColumns"
            @editRow="editRow"
            @delRow="delRow"
            @filterValuesChange="filterValuesChange"
            :persistFilterState="persistFilterState"
            @changeKey="changeKey"
          ></common-table>
        </div>
      </div>
    </div>
    <detailForm
       style="height:100%"
      v-else
      :item="currentItem"
      @closeDialog="closeDetail"
    ></detailForm>

    <!-- 编辑人员 -->
    <el-dialog
      title="编辑"
      :visible.sync="dialogVisible"
      width="500px"
      :modal="true"
      :close-on-click-modal="false"
    >
      <div class="container-dialog">
        <el-form
          :model="formInline"
          ref="form"
          label-width="110px"
          :rules="rules"
        >
          <el-form-item label="人员姓名" prop="userName">
            <el-input
              v-model="formInline.userName"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="phone">
            <el-input
              v-model="formInline.phone"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="标签类型" prop="tagTypeId">
            <el-select
              filterable
              placeholder="请选择"
              v-model="formInline.tagTypeId"
              @change="changetype"
            >
              <el-option
                v-for="item in tagTypeListFilter"
                :key="item. id"
                :label="item.tagType"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标签名称" prop="tagId">
            <el-select
              filterable
              placeholder="请选择"
              v-model="formInline.tagId"
            >
              <el-option
                v-for="item in tagNameList"
                :key="item.id"
                :label="item.tagName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="editFun" class="button-info">确认</el-button>
      </span>
    </el-dialog>

    <!-- 人员打标 -->
    <el-dialog
      title="人员打标"
      :visible.sync="dialogRenyuanVisible"
      width="80%"
      :modal="true"
      :close-on-click-modal="false"
    >
      <div class="dialog-body box">
        <div class="box-1 mr-10 item pl-10 pr-10 pb-10 relative">
          <div class="box box-between mb-10 pt-10" style="position: sticky;top: 0;background: #fff;z-index: 1;">
            <span class="leftLabel">人员</span>
            <el-button
              style="
                width: 40px;
                height: 40px;
                display: flex;
                justify-content: center;
                align-items: center;"
              class="search el-icon-plus button-info"
              @click="addRenOrLabel(1)"
            ></el-button>
          </div>
          <div class="box box-column-center mb-10" v-for="(item, index) in dialogUserList" :key="index">
            <span class="mr-10">人员姓名</span>
              <!-- :remote-method="(query) => {remoteMethod(query, index)}" -->
            <el-select
              class="mr-10 box-1"
              v-model="item.userId"
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="支持输入模糊和下拉选择"
              @change="changeUser(index)"
              :loading="loading">
              <el-option
                v-for="item in item.userList"
                :key="item.id"
                :label="item.userName"
                :value="item.id"
              ></el-option>
            </el-select>
            <span class="ml-10 mr-10">联系方式</span>
            <el-input class="mr-10 box-1" readonly size="small" v-model="item.phone" placeholder="自动填充"></el-input>
            <i class="el-icon-remove" style="font-size: 18px;color: #E0E0E0;cursor: pointer;" @click="delRenOrLabel(1, index)"></i>
          </div>
        </div>
        <div class="box-1 ml-10 item pl-10 pr-10 pb-10 relative">
          <div class="box box-between mb-10 pt-10" style="position: sticky;top: 0;background: #fff;z-index: 1;">
            <span class="leftLabel">标签</span>
            <el-button
              style="
                width: 40px;
                height: 40px;
                display: flex;
                justify-content: center;
                align-items: center;"
              class="search el-icon-plus button-info"
              @click="addRenOrLabel(2)"
            ></el-button>
          </div>
          <div class="box box-column-center mb-10" v-for="(item, index) in dialogtagList" :key="index">
            <span class="mr-10">标签类型</span>
            <el-select
              filterable
              placeholder="请选择"
              clearable
              v-model="item.tagTypeId"
              class="mr-10 box-1"
              size="small"
              @change="changeTagType(index)"
            >
              <el-option
                v-for="items in tagTypeList"
                :key="items. id"
                :label="items.tagType && items.tagType.length > 40 ? `${items.tagType.substring(0, 40)}...` : items.tagType"
                :value="items.id"
              ></el-option>
            </el-select>
            <span class="ml-10 mr-10">标签名称</span>
            <el-select
              filterable
              placeholder="请选择"
              clearable
              v-model="item.tagId"
              class="mr-10 box-1"
              size="small"
            >
              <el-option
                v-for="items in item.tagNameList"
                :key="items.id"
                :label="items.tagName"
                :value="items.id"
              ></el-option>
            </el-select>
            <i class="el-icon-remove" style="font-size: 18px;color: #E0E0E0;cursor: pointer;" @click="delRenOrLabel(2, index)"></i>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogRenyuanVisible = false">取消</el-button>
        <el-button type="primary" @click="editRenyuan" class="button-info">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  userTagRelationpage,
  userTagRelationdetail,
  userTagRelationupdate,
  userTagRelationdelete,
  userTagtagTypes,
  userTagpage,
  userTagRelationaddList,
  exportUserTagRelation,
  importUserTagRelation,
  deleteUserTagRelationList,
  generateImportFile
} from "@/api/base.js";
import {
  authUserlist,
} from "@/api/task.js";
import commonTable from "./components/table.vue"
import detailForm from "./detail.vue";
import { downloadFile } from "@/api/systemManagement.js";
import pageChangeSelect from "@/mixins/page-change-select.js";
import index from "@/mixins/index.js";
export default {
  components: {
    detailForm,
    commonTable
  },
  mixins: [index, pageChangeSelect],
  data() {
    return {
      // 人员打标
      dialogRenyuanVisible: false,
      // 编辑人员弹窗
      dialogVisible: false,
      formInline: {},
      rules: {
        tagId: [{ required: true, message: "请选择标签名称", trigger: "blur" }],
        tagTypeId: [{ required: true, message: "请选择标签类型", trigger: "blur" }],
      },
      tagTypeList: [],
      tagTypeListFilter: [],
      tagNameList: [],
      loading: false,
      // 标签管理
      dialogTableVisible: false,
      currentItem: {},
      exportLoading: false,
      importLoading: false,
      form: {
        userName: "",
        phone: "",
        tagName: "",
        tagType: "",
        tagId: "",
        tagTypeId: ""
      },
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "userName",
            label: "用户姓名",
            width: '200px'
          },
          {
            prop: "phone",
            label: "联系方式",
            width: '200px'
          },
          {
            prop: "deptName",
            label: "部门名称",
            width: '200px'
          },
          {
            prop: "createTime",
            label: "最近更新时间",
            width: '200px'
          },
        ]
      },
      actionColumns: [],
      dialogUserList: [],
      dialogtagList: [],
      userListDefault: [],
      selectedIdOptions: [],
      persistFilterState: {}, // 核心：持久化筛选状态 { 列名: 选中值数组 }
      freshFlag: 0,
      renderKey: 0
    };
  },
  mounted() {
    this.getPointTypeListPageFun(1);
    this.gettypeChange();
  },
  methods: {
    changeKey () {
      if (this.freshFlag <= 2) this.freshFlag += 1;
    },
    handleSelectionChange(val) {
      this.selectedIdOptions = val;
    },
    // 下载模板
    async downloadTemp () {
      let res = await generateImportFile({
        userPhone: this.form.phone,
        userName: this.form.userName,
        tagName: this.form.tagName,
        tagType: this.form.tagType,
        page: this.page.page,
        size: 9999,
      })
      let fileReader = new FileReader();
      fileReader.onload = function() {
        try {
          if (res.code == 300) {
            // 说明是普通对象数据，后台转换失败
            // proxy.MSG.error(res.message);
            return;
          } else {
            // 解析成对象失败，说明是正常的文件流
            let url = window.URL.createObjectURL(new Blob([res.data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.target = "_blank";
            link.setAttribute("download", "下载模板/导出数据.xlsx");
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
        } catch (err) {
          // console.log(err);
        }
      };
      fileReader.readAsText(res.data);
    },

    // 导出数据
    async exportData () {
      this.exportLoading = true;
      const params = {
        userPhone: this.form.phone,
        userName: this.form.userName,
        tagName: this.form.tagName,
        tagType: this.form.tagType,
        page: this.page.page,
        size: this.page.size,
      };
      const res = await exportUserTagRelation(params);
      // console.log("res :>> ", res);
      let fileReader = new FileReader();
      fileReader.onload = function() {
        try {
          if (res.code == 300) {
            // 说明是普通对象数据，后台转换失败
            // proxy.MSG.error(res.message);
            return;
          } else {
            // 解析成对象失败，说明是正常的文件流
            let url = window.URL.createObjectURL(new Blob([res.data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.target = "_blank";
            link.setAttribute("download", "人员标签数据.xlsx");
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
          this.exportLoading = false;
        } catch (err) {
          // console.log(err);
          this.exportLoading = false;
        }
      };
      fileReader.readAsText(res.data);
      this.exportLoading = false;
    },

    // 导入数据
    async importData(file) {
      if (!file.name.endsWith(".xlsx")) {
        this.$message({
          message: "请上传正确格式文件，支持文件类型：.xlsx",
          type: "warning"
        });
        return;
      }
      this.importLoading = true;
      let formData = new FormData();
      formData.append("file", file.raw);
      const res = await importUserTagRelation(formData);
      if (res.data.code == 200 && !res.data.data.filePath) {
        this.$message({
          message: `导入成功：${res.data.data.msg}`,
          type: "success"
        });
        setTimeout(() => {
          this.onSearch();
        }, 1000);
      } else if (res.data.code == 200 && res.data.data.filePath) {
        this.$message({
          message: `导入失败：${res.data.data.msg}`,
          type: "error"
        });

        let resFile = await downloadFile({
          filePath: res.data.data.relativePath
        });
        let fileReader = new FileReader();
        fileReader.onload = function() {
          try {
            if (resFile.code == 300) {
              // 说明是普通对象数据，后台转换失败
              // proxy.MSG.error(resFile.message);
              return;
            } else {
              // 解析成对象失败，说明是正常的文件流
              let url = window.URL.createObjectURL(new Blob([resFile.data]));
              let link = document.createElement("a");
              link.style.display = "none";
              link.href = url;
              link.target = "_blank";
              link.setAttribute("download", `${res.data.data.fileName}`);
              document.body.appendChild(link);
              link.click();
              window.URL.revokeObjectURL(url);
              document.body.removeChild(link);
            }
          } catch (err) {
            // console.log(err);
          }
        };
        fileReader.readAsText(resFile.data);
      } else {
        this.$message({
          message: '网络波动，请重新导入文件',
          type: "info"
        });
      }
      this.importLoading = false;
    },

    // 切换标签类型
    changetype () {
      this.eventPageFun();
    },

    // 获取全部标签类型
    async gettypeChange (e) {
      const res = await userTagtagTypes();
      this.tagTypeList = res.data.data || [];
    },

    // 获取全部标签名称
    async eventPageFun() {
      let params = {
        tagName: '',
        tagType: this.tagTypeList.find(item => item.id == this.formInline.tagTypeId).tagType,
        page: 1,
        size: 999,
      };
      const res = await userTagpage(params);
      if (res.data.code == 200) {
        this.tagNameList = res.data.data.records
          ? res.data.data.records
          : [];
      this.$nextTick(() => {
        this.formInline.tagId = this.formInline.tagInfoList && this.formInline.tagInfoList.length && this.formInline.tagInfoList.find(item => item.tagType == this.tagTypeList.find(item => item.id == this.formInline.tagTypeId).tagType) && this.tagNameList.find(item => item.tagName == this.formInline.tagInfoList.find(item => item.tagType == this.tagTypeList.find(item => item.id == this.formInline.tagTypeId).tagType).tagName) ? this.tagNameList.find(item => item.tagName == this.formInline.tagInfoList.find(item => item.tagType == this.tagTypeList.find(item => item.id == this.formInline.tagTypeId).tagType).tagName).id : '';
        // this.formInline.id = this.formInline.tagId || '';
      })
      }
    },
    
    // 获取部门资源树形
    async getUserList(query = '') {
      let params = {
        size: 5000,
        page: 1,
        keyword: query,
      };
      authUserlist(params).then((res) => {
        this.userListDefault = res.data.data.records;
        if (this.dialogUserList.length) {
          this.dialogUserList.forEach(item => item.userList = JSON.parse(JSON.stringify(res.data.data.records)))
        }
      });
    },

    // 提交人
    async remoteMethod(query, index) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          let params = {
            size: 100,
            page: 1,
            keyword: query,
          };
          authUserlist(params).then((res) => {
            this.dialogUserList[index].userList = res.data.data.records;
          });
        }, 200);
      } else {
        this.userList = this.userListDefault;
      }
    },

    // 人员打标 - 确认
    async editRenyuan () {
      if (!this.dialogUserList.length) this.$message.error('请添加人员');
      if (!this.dialogtagList.length) this.$message.error('请添加标签');
      if (this.dialogUserList && this.dialogUserList.length && this.dialogUserList.map(item => item.userId != '').includes(false)) return this.$message.error('请选择人员');
      if (this.dialogtagList && this.dialogtagList.length && this.dialogtagList.map(item => item.tagId != '').includes(false)) return this.$message.error('请选择标签名称');
      let list = [];
      this.dialogtagList.forEach(item => {
        this.dialogUserList.forEach(items => {
          list.push({
            userId: items.userId,
            tagId: item.tagId,
            tagTypeId: item.tagTypeId
          })
        })
      })
      let res = await userTagRelationaddList(list)
      if (res.data.code == 200) {
        this.$message.success('标记成功');
        this.dialogRenyuanVisible = false;
        this.getPointTypeListPageFun(1);
      }
    },
    openBiao () {
      this.dialogRenyuanVisible = true;
      this.dialogUserList = [];
      this.dialogtagList = [];
      this.addRenOrLabel(1);
      this.addRenOrLabel(2);
      setTimeout(() => {
        this.getUserList();
        this.gettypeChange();
      }, 500);
    },

    // 人员标记修改人员
    changeUser (index) {
      // console.log(index)
      if (!this.dialogUserList[index].userId) this.dialogUserList[index].phone = '';
      if (this.dialogUserList[index].userId && this.dialogUserList[index].userList.length) this.dialogUserList[index].phone = this.dialogUserList[index].userList.find(item => item.id == this.dialogUserList[index].userId).phone || '';
      else if (this.dialogUserList[index].userId && !this.dialogUserList[index].userList.length) this.dialogUserList[index].phone = this.userListDefault.find(item => item.id == this.dialogUserList[index].userId).phone || '';
      setTimeout(() => {
        if (this.dialogUserList.length != new Set(this.dialogUserList.map(item => item.userId)).size) this.$message.error('该人员已重复添加');
      }, 500);
    },

    // 人员标记修改标签
    async changeTagType (index) {
      if (this.dialogtagList[index].tagTypeId) {
        this.dialogtagList[index].tagId = [];
        let params = {
          tagName: '',
          tagType: this.tagTypeList.find(item => item.id == this.dialogtagList[index].tagTypeId).tagType,
          page: 1,
          size: 999,
        };
        const res = await userTagpage(params);
        if (res.data.code == 200) {
          this.dialogtagList[index].tagNameList = res.data.data.records
            ? res.data.data.records
            : [];
        }
      }
    },

    // 删除人员/标签
    delRenOrLabel (type, index) {
      if (type == 1) this.dialogUserList.splice(index, 1);
      else if (type == 2) this.dialogtagList.splice(index, 1);
    },

    // 添加人员/标签
    addRenOrLabel (type) {
      if (type == 1) this.dialogUserList.push({
        userId: '',
        userList: this.userListDefault,
        phone: '',
      })
      else if (type == 2) this.dialogtagList.push({
        tagTypeId: '',
        tagId: '',
        tagNameList: []
      })
    },

    // 编辑
    async editRow (row) {
      let res = await userTagRelationdetail({id: row.userId});
      if (res.data.code == 200) {
        this.formInline = JSON.parse(JSON.stringify(res.data.data));
        let tagTypeEditList = [];
        if (res.data.data.tagInfoList && res.data.data.tagInfoList.length) {
          tagTypeEditList = res.data.data.tagInfoList.filter(item => !item.editable);
        }
        this.tagTypeListFilter = this.tagTypeList.filter(item => !tagTypeEditList.includes(item.tagType));
        this.dialogVisible = true;
        if (this.formInline.tagTypeId) this.eventPageFun();
      }
    },
    // 编辑确认
    async editFun(submitFlag) {
      let xx = true;
      this.$refs["form"].validate(valid => {
        if (valid) {
          xx = true;
        } else {
          xx = false;
        }
      });
      if (xx == false) {
        this.$message({
          message: "请输入或选择必填项",
          type: "warning"
        });
        return false;
      }
      // console.log(this.tagTypeListFilter.find(item => item.id == this.formInline.tagTypeId))
      // console.log(this.tagTypeListFilter.find(item => item.id == this.formInline.tagTypeId).tagType)
      // console.log(this.formInline.tagInfoList)
      // console.log(this.formInline.tagInfoList.find(item => item.tagType == this.tagTypeListFilter.find(item => item.id == this.formInline.tagTypeId).tagType))
      let params = {
        // sxmc: this.formInline.sxmc,
        ...this.formInline,
        tagType: this.tagTypeList.find(item => item.id == this.formInline.tagTypeId).tagType,
        tagName: this.tagNameList.find(item => item.id == this.formInline.tagId).tagName,
        originalTagId: this.tagTypeListFilter.find(item => item.id == this.formInline.tagTypeId) && this.tagTypeListFilter.find(item => item.id == this.formInline.tagTypeId).tagType && this.formInline.tagInfoList && this.formInline.tagInfoList.length && this.formInline.tagInfoList.find(item => item.tagType == this.tagTypeListFilter.find(item => item.id == this.formInline.tagTypeId).tagType) ? this.formInline.tagInfoList.find(item => item.tagType == this.tagTypeListFilter.find(item => item.id == this.formInline.tagTypeId).tagType).tagId : '',
      };
      if (!params.originalTagId) delete params.originalTagId;
      // if (!params.originalTagId) params.originalTagId = '';
      const res = await userTagRelationupdate(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.dialogVisible = false;
        this.getPointTypeListPageFun();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    async multipleDelRow () {
      if (!this.selectedIdOptions.length) return this.$message.error('请先选择数据')
      const isok = await this.$confirm("是否批量删除选中数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => true)
        .catch(() => false);
      if (!isok) {
        return;
      }
      const res = await deleteUserTagRelationList(this.selectedIdOptions.map(item => item.userId));
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "批量删除成功"
        });
        this.getPointTypeListPageFun(1);
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    
    // 删除
    async delRow(row) {
      if (!row.userId) return false;
      const isok = await this.$confirm("是否清空该用户的所有标签数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => true)
        .catch(() => false);
      if (!isok) {
        return;
      }
      const res = await userTagRelationdelete({
        id: row.userId
      });
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "清空成功"
        });
        this.getPointTypeListPageFun(1);
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    closeDetail () {
      this.dialogTableVisible = false;
      this.getPointTypeListPageFun();
    },
    // 查看详情
    qusetionDetail(row) {
      this.currentItem = row;
      this.dialogTableVisible = true;
    },
    handleSizeChange(val) {
      this.page.size = val;
      // 将 persistFilterState 转换为数组格式传递
      const filterValues = Object.keys(this.persistFilterState).map(column => ({
        column: column,
        values: this.persistFilterState[column]
      }));
      this.getPointTypeListPageFun(1, filterValues);
    },
    handleCurrentChange(val) {
      this.page.page = val;
      // 将 persistFilterState 转换为数组格式传递
      const filterValues = Object.keys(this.persistFilterState).map(column => ({
        column: column,
        values: this.persistFilterState[column]
      }));
      this.getPointTypeListPageFun(val, filterValues);
    },
    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
    },
    onReset() {
      this.form.userName = '';
      this.form.phone = '';
      this.form.tagName = '';
      this.form.tagType = '';
      this.page.page = 1;
      this.page.size = 10;
      this.persistFilterState = {}; // 清空父组件筛选缓存
      this.getPointTypeListPageFun();
    },
    filterValuesChange (val) {
      // console.log('--------------val :>> ', val);
      // 将子组件传递的筛选数组转为对象（方便存储和恢复）
      const filterObj = {};
      val.forEach(item => {
        filterObj[item.column] = item.values;
      });
      this.persistFilterState = filterObj; // 父组件持久化存储
      this.getPointTypeListPageFun(1, val);
    },
    // 分页查询
    async getPointTypeListPageFun(val, filterValues) {
      if (val && val == 1) this.page.page = 1;
      let tagTypeIdList = [];
      if (filterValues && filterValues.length) {
        tagTypeIdList = tagTypeIdList.concat(...filterValues.map(item => item.values));
        // console.log('--------------tagTypeIdList :>> ', tagTypeIdList);
      }
      let params = {
        ...this.form,
        userPhone: this.form.phone,
        page: this.page.page,
        size: this.page.size,
        tagTypeIdList
      };
      if (!tagTypeIdList.length) delete params.tagTypeIdList;
      const res = await userTagRelationpage(params);
      if (res.data.code == 200) {
        try {
          // 先处理数据，生成新的 tableData 和 actionColumns
          const newTableData = res.data ? (res.data.data.records
            ? res.data.data.records
            : []) : [];
          const newActionColumns = [];
          const newTotal = res.data ? res.data.data.total : 0;

          if (newTableData.length && newTableData[0].typeMap) {
            Object.keys(newTableData[0].typeMap).forEach(key => {
              newActionColumns.push({
                label: key,
                value: newTableData[0].typeMap[key]
              });
            });
            newTableData.forEach(item => {
              if (item.typeMap && typeof item.typeMap === 'object') {
                Object.keys(item.typeMap).forEach(key => {
                  item[key] = item.typeMap[key];
                });
              }
            });
          }

          // 完全替换 dataList 对象，触发 Vue 2 响应式更新
          this.dataList = {
            ...this.dataList,
            tableData: newTableData
          };
          this.page.total = newTotal;
          this.actionColumns = newActionColumns;
          this.renderKey++; // 强制刷新子组件
        } catch (error) {
          console.error('处理表格数据异常:', error);
        }
      } else return this.$message.error(res.data.msg)
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";
/deep/ .button-primary {
  border-radius: 4px;
  padding: 0px 12px;
  background: #fff;
  border: 1px solid #0054FE;
  font-family: MiSans;
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  color: #0054FE;
}
// /deep/ .button-danger {
//   border-radius: 4px;
//   padding: 0px 12px;
//   background: #fff;
//   font-family: MiSans;
//   font-size: 16px;
//   font-weight: normal;
//   line-height: normal;
//   color: red;
//   margin-right: 20px;
// }
/deep/ .button-info {
  background: #0054FE !important;
}
.box-father {
  background: #F1F4F6 !important;
  overflow: hidden !important;
}
.postImg {
  width: 98px;
  height: 48px;
  border-radius: 8px;
}

.caogao {
  color: #0054FE;
  background: rgba(0, 84, 254, 0.0966);
  border-radius: 4px;
  padding: 2px 15px;
}

.yifabu {
  color: #00AC94;
  background: rgba(0, 172, 148, 0.0966);
  border-radius: 4px;
  padding: 2px 15px;
}

.yxj {
  color: #8C949C;
  background: rgba(140, 148, 156, 0.0966);
  border-radius: 4px;
  padding: 2px 15px;
}

.cl-primary {
  color: #008cff;
}
.mr-40 {
  margin-right: 40px;
}
.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}

.tuihui {
  color: #eb3538;
  font-size: 16px;
}

.fileJson {
  img {
    margin-right: 10px;
    margin-bottom: 10px;
  }
}

/deep/ .el-carousel__arrow {
  width: 54px !important;
  height: 54px !important;
  font-size: 18px !important;
}
.pass {
  color: #17b3ad;
}
.noPass {
  color: #ff5348;
}
.warin {
  color: #FFA200;
}
.box {
  display: flex;
}
.box-1 {
  flex: 1;
}
.box-2 {
  flex: 2;
}
.box-3 {
  flex: 3;
}
.box-7 {
  flex: 7;
}
.box-wrap {
  flex-wrap: wrap;
}
.box-column {
  flex-direction: column;
}
.box-column-center {
  align-items: center;
}
.box-center {
  justify-content: center;
}
.box-center {
  justify-content: center;
  align-items: center;
}
.box-between {
  justify-content: space-between;
}
.border-bottom {
  border-bottom: 1px solid #e4e4e4;
}
.p-15 {
  padding: 15px;
}
.pb-10 {
  padding-bottom: 10px;
}
.pb-20 {
  padding-bottom: 20px;
}
.mt-20 {
  margin-top: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mr-10 {
  margin-right: 10px;
}
.ml-10 {
  margin-left: 10px;
}
.bold {
  font-weight: bold;
}
.w100 {
  width: 130px;
}
.mb-10 {
  margin-bottom: 10px;
}
.pointer {
  cursor: pointer;
}
.mt-16 {
  margin-top: 16px;
}
.p-10 {
  padding: 10px;
}
.pt-10 {
  padding-top: 10px;
}
.pl-10 {
  padding-left: 10px;
}
.pr-10 {
  padding-right: 10px;
}
.pb-10 {
  padding-bottom: 10px;
}
.dialog-body {
  .item {
    height: 500px;
    overflow: auto;
    border-radius: 4px;
    border: 1px solid #E0E0E0;
    .leftLabel {
      font-family: MiSans;
      font-size: 20px;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 0px;
      color: #494C4F;
    }
  }
}
.editClass {
  color: #0090ff;
  font-size: 16px;
}
.delClass {
  color: #eb3538;
  font-size: 16px;
}
.box {
  display: flex;
}
.box-end {
  justify-content: flex-end;
}

/deep/ .custom-table,  .el-table__body-wrapper {
  overflow-x: auto !important; /* 强制横向滚动 */
  overflow-y: auto; /* 保留纵向滚动 */
}

/* 局部修改表头背景色（scoped下必须用深度选择器） */
/deep/ .custom-table::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(233, 233, 233, 70%);
}
</style>



// WEBPACK FOOTER //
// src/pages/personLabel/index.vue